import { StudentsListDtoResponse } from '../../../../interfaces/Student/StudentsListDtoResponse';
import { Select } from 'antd';

type Options = StudentsListDtoResponse[];

const { Option } = Select;

interface Props {
  placeholder: string;
  selectedOption: number | undefined;
  options: Options;
  onSelect: (value: number) => void;
  width?: number;
}

const StudentsFilter = ({ placeholder, selectedOption, options, onSelect, width }: Props) => {
  return (
    <Select placeholder={placeholder} value={selectedOption} onSelect={onSelect} style={{ width: '100%' }}>
      {options.map((option) => (
        <Option key={option.userId} value={option.userId}>
          {`${option.name} ${option.surname}`}
        </Option>
      ))}
    </Select>
  );
};
export default StudentsFilter;
